import React from "react";
import {
  Facebook,
  Instagram,
  WhatsApp,
  Chat,
  Send,
  VerifiedUser,
} from "@material-ui/icons";
import whatsmeowIcon from "../../assets/whatsmeow.png";
import wahaIcon from "../../assets/waha-icon.png";
import evolutionIcon from "../../assets/evolution-icon.png";

const imgStyle = (size) => ({
  width: size,
  height: size,
  verticalAlign: "middle",
  objectFit: "contain",
});

/**
 * Ícone do canal de conexão (Baileys, WuzAPI/Meow, Meta, etc.).
 * @param {string} channel
 * @param {{ size?: number }} [options]
 */
const IconChannel = (channel, options = {}) => {
  const size = options.size ?? 20;
  const normalizedChannel = channel ? String(channel).toLowerCase().trim() : "";

  switch (normalizedChannel) {
    case "facebook":
      return (
        <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />
      );
    case "instagram":
      return (
        <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />
      );
    case "whatsapp":
      return (
        <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
      );
    case "whatsapp_oficial":
      return (
        <VerifiedUser
          style={{ color: "#0a9e49", verticalAlign: "middle" }}
          fontSize="small"
        />
      );
    case "waha":
      return <img src={wahaIcon} alt="Whatsapp02" style={imgStyle(size)} />;
    case "evolution":
      return <img src={evolutionIcon} alt="Whatsapp03" style={imgStyle(size)} />;
    case "wuzapi":
    case "whatsmeow":
      return (
        <img
          src={whatsmeowIcon}
          alt="Whatsapp01"
          style={imgStyle(size)}
        />
      );
    case "webchat":
      return <Chat style={{ color: "#0066ff", verticalAlign: "middle" }} />;
    case "telegram":
      return <Send style={{ color: "#229ED9", verticalAlign: "middle" }} />;
    default:
      return (
        <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
      );
  }
};

export default IconChannel;
